import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from 'react-query';
import { Avatar } from '@folio/stripes-components';
import css from './styles.css';
import { useNamespace } from '../../Namespace';
import useOkapiKy from '../../../useOkapiKy';

const propTypes = {
  user: PropTypes.object,
};

function UserProfilePicture({ user }, options = {}) {
  const { name, profilePictureLink } = user;
  const ky = useOkapiKy();
  const [namespace] = useNamespace({ key: 'userProfilePicture' });
  const { isFetching, data = {} } = useQuery(
    [namespace, profilePictureLink],
    () => {
      return ky.get(`users/profile-picture/${user.profilePictureLink}`).json();
    },
    {
      enabled: Boolean(profilePictureLink),
      ...options,
    },
  );

  const profilePictureSrc = 'data:;base64,' + data?.profile_picture_blob;

  if (!profilePictureLink) {
    return (
      <Avatar alt={name} ariaLabel={name} className={css.avatar} />
    );
  }

  if (isFetching) {
    return (
      <div className={css.loader}>
        <Avatar alt={name} ariaLabel={name} className={css.avatar} />
      </div>
    );
  }

  return (
    <Avatar
      src={profilePictureSrc}
      alt={name}
      ariaLabel={name}
      className={css.avatar}
    />
  );
}

UserProfilePicture.propTypes = propTypes;

export default UserProfilePicture;
